<template>
  <main id="pwa-install-prompt-container">
    <h1>{{ $t('pwaInstallPrompt.title') }}</h1>
    <p>{{ $t('pwaInstallPrompt.message') }}</p>
    <section id="pwa-install-prompt-input-section">
      <button
        type="button"
        class="btn flex-btn green-btn btn-text-icon-center"
        @click="acceptClicked"
      >
        <CheckIcon />{{ $t('pwaInstallPrompt.acceptBtn') }}
      </button>
      <button
        type="button"
        class="btn flex-btn blue-btn btn-text-icon-center"
        @click="declineClicked"
      >
        <CloseIcon />{{ $t('pwaInstallPrompt.declineBtn') }}
      </button>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';

export default defineComponent({
  components: { CheckIcon, CloseIcon },
  emits: ['installDeclined', 'installAccepted'],

  methods: {
    acceptClicked() {
      console.log('Pwa install accept clicked');
      this.$emit('installAccepted');
    },
    declineClicked() {
      console.log('Pwa install decline clicked');
      this.$emit('installDeclined');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/scss/__variables.scss';

h1 {
  font-size: 1.6em;
  padding-bottom: 0.5em;
}

.flex-btn {
  display: flex;
  gap: 0.8em;
}

.green-btn {
  background-color: $button-green;
  color: white;
  border-color: $button-green;
}

.green-btn:hover {
  background-color: $button-hover-green;
}

.blue-btn {
  background-color: $button-blue;
  color: white;
  border-color: $button-blue;
}

.blue-btn:hover {
  background-color: $button-hover-blue;
}

#pwa-install-prompt-input-section {
  display: flex;
  justify-content: space-around;
  gap: 1em;
}
</style>
